<div class="header-tab text-center mb-3 mt-3">
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div [ngClass]="commonService.isTabSelected(0) ? 'selectedTab' : 'defaultTab' "
                [class.selectedTab]="commonService.isTabSelected(0)" (click)="showBasicDetails() ">
                Basic Details
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div [ngClass]="commonService.isTabSelected(2) ? 'selectedTab' : 'defaultTab' "
                [class.selectedTab]="commonService.isTabSelected(2)" (click)="showPaymentDetails()">
                Other Details
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div [ngClass]="commonService.isTabSelected(1) ? 'selectedTab' : 'defaultTab' "
                [class.selectedTab]="commonService.isTabSelected(1)" Email (click)="commonService.selectTab(1)">
                Address & Bank Details
            </div>
        </div>
        <div class="col-xs-3 col-sm-12 col-md-3 col-lg-3">
            <div [ngClass]="commonService.isTabSelected(3) ? 'selectedTab' : 'defaultTab' "
                [class.selectedTab]="commonService.isTabSelected(3)" (click)="commonService.selectTab(3)">
                Document
            </div>
        </div>
    </div>
</div>

<!-- basic Details Tab -->
<div [ngClass]="commonService.isTabSelected(0) ? 'classblock' : 'classnone'">
    <app-basic-details [allotmentRelatedData]="allotmentRelatedData" [formGroup]="allotmentForm"
        (submitForm)="onSubmit()"></app-basic-details>
</div>

<!-- payment Details Tab -->
<div [ngClass]="commonService.isTabSelected(2) ? 'classblock' : 'classnone'">
    <app-receipt-details [allotmentRelatedData]="allotmentRelatedData"
        [formGroup]="allotmentForm"></app-receipt-details>
</div>

<!-- address Details Tab -->
<div [ngClass]="commonService.isTabSelected(1) ? 'classblock' : 'classnone'">
    <app-address-details></app-address-details>
</div>

<!-- document Details Tab -->
<div [ngClass]="commonService.isTabSelected(3) ? 'classblock' : 'classnone'">
    <app-document-details></app-document-details>
</div>